
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TodoForm.html?raw';
import "../../../moreCore/UI/CheckBox/CheckBox";
import DateInput from '../../../moreCore/UI/DateInput/DateInput';
import "../../../moreCore/UI/DateInput/DateInput";
import "../../../moreCore/UI/StaticTable/StaticTable";
import { TodoListTypes, MemberTodoEntry, MemberTodoEntryV2 } from "../../_loadingHelpers/TodoList"
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _TabEnabledMixin from '../../../moreCore/UI/Tabbing/_TabEnabledMixin';
import ExpandableSection from '../../../moreCore/UI/Container/ExpandableSection';
class TodoForm extends compose(_StatefulSection, _TabEnabledMixin) {
    templateString: any = template;

    private noteContainer: HTMLElement;
    private memberContainer: HTMLElement;
    private finishedIcon: HTMLElement;
    //private entityId: string = null;
    private inputDueDate: MdsLax<InstanceType<typeof DateInput>>;
    private txtDueDate: HTMLElement;
    private dueDateContainer: HTMLElement;
    private dueDateWarningContainer: HTMLElement;

    private _request: any = null;
    private entityData: TodoListTypes.TodoAppointmentEntity = null;


    afterSetData() {
        let data = this.sourceData as TodoListTypes.TodoAppointmentEntity;
        this.entityData = data;

        if (this.isEmbeddedInTab) {
            this.changeTabColor(data.statusColorHex);
        }

        this.UiModder.domClass.toggle(this.finishedIcon, "fas w3-text-green", data.is_finished);
        this.UiModder.domClass.toggle(this.finishedIcon, "far w3-disabled", !data.is_finished);

        //    this.setupTable(data.todoMembers, data._todoMembersTableLayouts);
        this.setupMemberEntries(data.todoMembers);

        let dueDate: Date = this.inputDueDate.getValue();
        let now: Date = new Date();
        let isOverDue = dueDate.valueOf() < now.valueOf() && this.entityData.is_finished != true;
        
        this.UiModder.domClass.toggle(this.dueDateContainer, "warningBG", isOverDue);
        this.UiModder.domClass.toggle(this.txtDueDate, "bold", isOverDue);
        this.hideNode(this.dueDateWarningContainer, !isOverDue);

        this.hideNode(this.noteContainer, !data.note);
    }


    private setupMemberEntries(data: Array<TodoListTypes.TodoMemberEntity>) {
        let currentEmployeeID = window.sessionInfo?.sessionData?.CurrentEmployeeId;
        this.UiModder.domConstruct.empty(this.memberContainer);
        for (let entry of data) {
            //let expander = new ExpandableSection();
            //expander.placeAt(this.memberContainer);

            

            let memberForm = this.hasFeature("TodoList/MemberTodoEntryV2") ? new MemberTodoEntryV2() : new MemberTodoEntry();

            memberForm.placeAt(this.memberContainer);
            if (this.hasFeature("TodoList/MemberTodoEntryV2")) {
                let statusValues = this.getAttributeValue("statusValues");
                entry["statusValues"] = statusValues;
                entry["is_todo_finished"] = this.getAttributeValue("is_finished");
            }
            memberForm.setData(entry);

            //memberForm.on("dirty", lang.hitch(this, this._onMemberDirty, entry, memberForm, expander));
            //memberForm.on("saved", lang.hitch(this, this._onMemberSaved, entry, memberForm, expander));
            memberForm.on("saved", lang.hitch(this, this._onMemberSaved, entry, memberForm, null));

        //    let marking: ExpandableSectionMarkings = ExpandableSectionMarkings.empty;
        //    if (entry.memberID == currentEmployeeID) {
        //        marking = ExpandableSectionMarkings.hasContent;
        //        if (entry.is_finished) {
        //            marking = ExpandableSectionMarkings.checked;
        //        }
        //    }

        //    expander.setup(memberForm.domNode,
        //        (entry.task_description ? entry.task_description : this.entityData.c_todo_description) + " - " + entry.memberName,
        //        "small",
        //        true,
        //        true,
        //        entry.memberID == currentEmployeeID && entry.is_finished != true,
        //        marking
        //    );

        //    expander.setMarking(marking);
        }
    }

    private _onMemberDirty(memberEntity: TodoListTypes.TodoAppointmentEntity, widget: MdsLax<InstanceType<typeof MemberTodoEntry>>, expander: MdsLax<InstanceType<typeof ExpandableSection>>, state: boolean) {

    } 
    private _onMemberSaved(memberEntity: TodoListTypes.TodoAppointmentEntity, widget: MdsLax<InstanceType<typeof MemberTodoEntry>>, expander: MdsLax<InstanceType<typeof ExpandableSection>>, state: boolean) {
        this.loadData(this.entityId);
    }

    onDirtyChange(newState: boolean) {

    }

    loadData(todoID: string): void {

        this.entityId = todoID;


        if (this._request != null) {
            this._request.cancel();
        }

        if (!this.entityId) return;

        let data = { todoAppointmentID: this.entityId };

        this.StandbyStart();

        this.setStartupState("loading");

        this._request = this.RequestManager.post(
            window.appRoot + "TodoList/LoadDetails",
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onLoadData_Response),
            lang.hitch(this, this._onLoadData_Error)

        );

    }


    private _onLoadData_Response(response: TodoListTypes.TodoAppointmentEntity): void {
        //console.log("ToDoListEditor _onLoadData_Response: ", response);

        this.StandbyStop();

        if (response) {
            this.setData(response);
        }
    }

    private _onLoadData_Error(error: more.requestErrorMessage) {

        this.StandbyStop();

        alert(this.id + " " + error.Message);
    }



    //private saveData(): void {

    //    this.StandbyStart();

    //    if (this._request != null) {
    //        this._request.cancel();
    //    }

    //    let data = this.currentData;

    //    this.RequestManager.post(
    //        window.appRoot + "TodoList/SaveTodoEntity",
    //        {
    //            "jsonData": JSON.stringify(data)
    //        },
    //        lang.hitch(this, this._onSaveData_Response),
    //        lang.hitch(this, this._onSaveData_Error)
    //    );

    //}


    //private _onSaveData_Response(response): void {
    //    //this.StandbyStop();
    //    this.resetDirty();

    //    this.emit("saved", true);

    //    this.loadData(this.entityId);

    //    this.showToast({
    //        title: this.translations["General__SaveSuccess"],
    //        iconClass: toasterIcons.confirmCheck
    //    });


    //}

    //private _onSaveData_Error(error: more.requestErrorMessage) {
    //    this.StandbyStop();
    //}

    _onEmbedding() {
        this.UiModder.domClass.add(this.domNode, "w3-content sectionBG");
    }
    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TodoForm);